// extracted by mini-css-extract-plugin
export default {"container":"Header_container__-5eVG","heading":"Header_heading__rY1zI","right":"Header_right__2pGXv"};